<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Alert, Input, Select, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { gen2Request } from 'src/services/gen_2_http_reqs';

	let className = '';
	export { className as class };

	export let device: any;
	export let settings: any,
		icon: string = '';

	const IO_NUM = 3;
	let inputs: { index: number; mode: string }[] = Array(IO_NUM).fill(null);

	const options = [
		{
			title: $format('disabled', { default: 'Disabled' }),
			value: 'none',
		},
		{
			title: $format('settings_pill_options_digital_in', {
				default: 'Digital Input (Active Low)',
			}),
			value: 'digital_in',
		},
		{
			title: $format('settings_pill_options_digital_out', {
				default: 'Digital Output',
			}),
			value: 'digital_out',
		},
	];

	let waitingRorRequest = false;

	$: inputs = inputs.map((_, i) => {
		return {
			index: i,
			mode: settings?.pill?.[`pin${i}_mode`],
		};
	});

	const pinModeKey = (index: number) => `pin${index}_mode`;

	const onChange = async (input_idx: number, value: string) => {
		if (waitingRorRequest) return;
		waitingRorRequest = true;
		const res: SettingRequest = await gen2Request(device, 'Pill.SetConfig', {
			config: { [pinModeKey(input_idx)]: value },
		});
		if (res.isok) {
			settings.pill[pinModeKey(input_idx)] = value;
		}

		onSettingsResponse(res, device);

		waitingRorRequest = false;
	};
</script>

<div class={className}>
	<Alert
		type="info"
		class="mb-m"
		heading={$format('alert_pill_peripheral_digital_level_heading', {
			default: 'IO Logic Levels',
		})}
		message={$format('alert_pill_peripheral_digital_level', {
			default:
				'Logic Level: 3.3V. Ensure connected peripherals are compatible with this voltage to prevent damage.',
		})}
	/>
	{#each inputs as input}
		<Text styleType="body-small" class="mb-s mt-s">
			{$format('subtitle_pill_peripheral_io_num', {
				default: 'Digital IO #{num}',
				values: { num: input.index + 1 },
			})}
		</Text>
		{#if input.mode === 'reserved'}
			<Input
				aria-label={$format('input_pill_peripheral_io_reserved', {
					default: 'Pill peripheral IO reserved',
				})}
				size="m"
				width="full"
				disabled={true}
				icon={'fa fa-sensor-on'}
				value={$format('pill_io_reserved', { default: 'Reserved' })}
				id="input-n1zsp6b"
			/>
		{:else}
			<Select
				aria-label={$format('select_pill_peripheral_io_mode', {
					default: 'Select pill peripheral IO mode',
				})}
				size="m"
				width="full"
				disabled={waitingRorRequest}
				{icon}
				{options}
				value={options.find((i) => i.value == input.mode) || options[0]}
				on:change={(e) => onChange(input.index, e.detail['value'])}
				id="select-jhinwii"
			/>
		{/if}
	{/each}
</div>
